export const PROFILE_CLASSIFIEDS_REQUESTING = 'PROFILE_CLASSIFIEDS_REQUESTING'
export const PROFILE_CLASSIFIEDS_REQUEST_SUCCESS = 'PROFILE_CLASSIFIEDS_REQUEST_SUCCESS'
export const PROFILE_CLASSIFIEDS_REQUEST_ERROR = 'PROFILE_CLASSIFIEDS_REQUEST_ERROR'

export const PUBLIC_CLASSIFIEDS_REQUESTING = 'PUBLIC_CLASSIFIEDS_REQUESTING'
export const PUBLIC_CLASSIFIEDS_REQUEST_SUCCESS = 'PUBLIC_CLASSIFIEDS_REQUEST_SUCCESS'
export const PUBLIC_CLASSIFIEDS_REQUEST_ERROR = 'PUBLIC_CLASSIFIEDS_REQUEST_ERROR'
